<app-sharepoint-table
    #tableGrid
    class="position-table"
    [configuration]="tableConfig"
    (onTooolbarButtonClick)="onTooolbarButtonClick($event)">
</app-sharepoint-table>
